var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMspUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7,
    rx: 7.5,
    ry: 7,
    fill: "#16325C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15 8.688l.763-.325c-.212-.163-.337-.413-.337-.613C7.576 6.525 10 6.362 10 4.475c0-1.075-.925-1.937-2.45-1.937-1.188 0-2.113.5-2.713 1.275l.625.674c.463-.612 1.05-1.025 1.988-1.025.987 0 1.475.538 1.475 1.163 0 1.325-2.263 1.463-2.263 3.05 0 .375.15.725.488 1.013zm.263 2.437a.694.694 0 00.688-.688.694.694 0 00-.688-.687.694.694 0 00-.687.688c0 .374.312.687.687.687z",
    fill: "#fff"
  })));
}
export default SvgMspUnknown;